module.exports = __webpack_public_path__ + "img/sideBarBottom.48f683b0.svg";